import {http} from "@/api/http";
import {API_URL, ID_API_URL} from "@/api/base";


export async function getToken(username, password) {
    const params = new URLSearchParams();
    params.append('username', username);
    params.append('password', password);
    return await http.post(`${ID_API_URL}/v1/auth/token`, params, {skipAuth: true})
}

export async function registerUser(userData) {
    return await http.post(`${ID_API_URL}/v1/user/register`, userData, {skipAuth: true})
}

export async function getUser(user_id) {
    return await http.get(
        `${ID_API_URL}/v1/user/${user_id}/info`
    )
}

/**
 * Редактирование данных пользователя
 * @param {string} user_id - ID пользователя
 * @param {Object} userData - Данные для обновления { name?, email?, phone?, password?, onboarded? }
 * @returns {Promise}
 */
export async function updateUser(user_id, userData) {
    return await http.patch(
        `${ID_API_URL}/v1/user/${user_id}`,
        userData,
        {headers: {'Content-Type': 'application/json'}}
    )
}

/**
 * Получает URL для OAuth авторизации провайдера
 * @param {string} provider - Название провайдера (например, 'ozon')
 * @returns {Promise} Promise с данными {authorization_url, state}
 */
export async function getOAuthAuthorizationUrl(provider) {
    return await http.get(
        `${API_URL}/v1/auth/oauth/${provider}/authorize`,
        {skipAuth: true}
    )
}

/**
 * Обрабатывает OAuth callback от провайдера
 * @param {string} provider - Название провайдера (например, 'ozon')
 * @param {string} code - Код авторизации от провайдера
 * @param {string} state - State параметр для проверки безопасности
 * @param {string} timezone - Часовой пояс пользователя
 * @returns {Promise} Promise с данными {access_token, refresh_token}
 */
export async function processOAuthCallback(provider, code, state, timezone) {
    return await http.post(
        `${API_URL}/v1/auth/oauth/${provider}/callback`,
        {
            code: code,
            state: state,
            timezone: timezone
        },
        {skipAuth: true}
    )
}

/**
 * Обрабатывает OAuth callback для создания магазина
 * @param {string} provider - Название провайдера (например, 'ozon')
 * @param {string} code - Код авторизации от провайдера
 * @param {string} state - State параметр для проверки безопасности
 * @param {string} company_id - ID компании для создания магазина
 * @returns {Promise} Promise с данными {store_id}
 */
export async function processOAuthStoreCallback(provider, code, state, company_id) {
    return await http.post(
        `${API_URL}/v1/auth/oauth/${provider}/store/callback`,
        {
            code: code,
            state: state,
            company_id: company_id
        }
    )
}
